module.exports = __webpack_public_path__ + "media/scholarship_winners/amanda-ma-sw-faca5c14.png";